import * as TYPES from './constants';
import {API} from 'config/employer.config';
import {JWT_HEADER, JSON_HEADER} from 'config/srm.config';
import {
  requestAllTalentList,
  receiveAllTalentList,
  handleAllTalentListError,
} from './actions';
import {Services} from 'core';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ALL_TALENT_LIST_REQUEST:
      return {
        ...state,
        request: true,
      };
    case TYPES.ALL_TALENT_LIST_RECEIVE:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.ALL_TALENT_LIST_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.CLEAR_ALL_TALENT_LIST:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const fetchAllTalentList = (bodyData, filters) => (
  dispatch,
  getState
) => {
  const {
    auth: {
      access: {token},
    },
    instance: {
      data: {institution_id},
    },
  } = getState();
  const {page = 1, page_size = 50, filters = []} = bodyData;
  let payload = bodyData;
  if (bodyData?.filters) {
    delete payload.filters;
  }
  if (payload?.pageSize) {
    delete payload.pageSize;
  }
  if (filters && filters.length > 0) {
    filters.forEach(filter => {
      payload[filter.key] = filter.value;
    });
  }
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', 'Bearer ' + token);
  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    redirect: 'follow',
    body: JSON.stringify({
      ...payload,
      page,
      page_size,
      institution_uuid: institution_id,
    }),
  };
  dispatch(requestAllTalentList());
  try {
    let URI = `${API.administration.all_talents}`;
    fetch(URI, requestOptions)
      .then(response => response.json())
      .then(json => {
        console.log('Fetching All Talent List', URI, bodyData, json);
        dispatch(receiveAllTalentList(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleAllTalentListError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleAllTalentListError(err));
  }
};
